import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle2, ArrowRight, Zap, Image as ImageIcon, Check } from 'lucide-react';
import { Footer } from '../components/Footer';
export function CheckoutLloydPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const mainPrice = 27;
  const bump1Price = 47;
  const bump2Price = 17;
  const total = mainPrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.5
    }
  };
  const handlePurchase = () => {
    // Redirect to Shopify checkout — replace with real permalink
    window.location.href = 'https://shopify.com';
  };
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#06b6d4] selection:text-black" data-id="element-1363" data-mp="28fdv1f8kl79u">
      {/* Header */}
      <header className="border-b border-gray-800 bg-black/50 backdrop-blur-md sticky top-0 z-50" data-id="element-1364" data-mp="1sh0iri4bdbsp">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-1365" data-mp="1nkjsoidk0ncz">
          <div className="flex items-center gap-2" data-id="element-1366" data-mp="1irgzibcovfxb">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#06b6d4] to-[#0891b2] flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]" data-id="element-1367" data-mp="1iq5xoh2t0i8u">
              <Zap className="w-5 h-5 text-white" data-id="element-1368" data-mp="18vw1spenl1td" />
            </div>
            <span className="font-black text-xl tracking-tight" data-id="element-1369" data-mp="14shjfs38s9cr">HeyLloyd</span>
          </div>
          <div className="flex items-center gap-2 text-emerald-400 text-sm font-medium bg-emerald-400/10 px-3 py-1.5 rounded-full border border-emerald-400/20" data-id="element-1370" data-mp="zsuwgqxm3eqr">
            <Lock className="w-4 h-4" data-id="element-1371" data-mp="uwwfhoem4z0d" />
            <span data-id="element-1372" data-mp="2u7xk0j33omr1">Pago 100% Seguro</span>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 md:py-12 space-y-8" data-id="element-1373" data-mp="2p82r69zrln3c">
        {/* Page Title */}
        <motion.div {...fadeIn} className="text-center" data-id="element-1374" data-mp="nivi3lkldf7j">
          <h1 className="text-2xl md:text-3xl font-black mb-2" data-id="element-1375" data-mp="nhc0nrn78y46">Tu Orden</h1>
          <p className="text-gray-400" data-id="element-1376" data-mp="sax1rsk3a87l">
            Selecciona tus complementos y completa tu compra.
          </p>
        </motion.div>

        {/* Main Product */}
        <motion.div {...fadeIn} transition={{
        delay: 0.1
      }} className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6" data-id="element-1377" data-mp="ijsp4zhvyzfx">
          <div className="flex items-center gap-4" data-id="element-1378" data-mp="16afx1krsxp2h">
            <div className="w-14 h-14 bg-gradient-to-br from-[#06b6d4]/20 to-[#0891b2]/20 rounded-xl flex items-center justify-center border border-[#06b6d4]/30 shrink-0" data-id="element-1379" data-mp="1b9j3n9nfk3ck">
              <Zap className="w-7 h-7 text-[#06b6d4]" data-id="element-1380" data-mp="we33cmw9bb7q" />
            </div>
            <div className="flex-1" data-id="element-1381" data-mp="1198rzth1n3zi">
              <h2 className="text-lg md:text-xl font-bold text-white" data-id="element-1382" data-mp="3h1xzls95vgzi">
                HeyLloyd Assistant
              </h2>
              <p className="text-sm text-gray-400" data-id="element-1383" data-mp="3m1at2vujfmb2">
                Tu asistente de creación digital con IA — Acceso Inmediato
              </p>
            </div>
            <p className="text-2xl font-black text-white shrink-0" data-id="element-1384" data-mp="2458u6fmf2f9j">
              ${mainPrice}
            </p>
          </div>
        </motion.div>

        {/* Order Bumps */}
        <motion.div {...fadeIn} transition={{
        delay: 0.2
      }} className="space-y-4" data-id="element-1385" data-mp="2d3b0naox6047">
          <h2 className="text-lg font-bold text-gray-300" data-id="element-1386" data-mp="293aaissgk0hb">
            Mejora tu orden (Opcional)
          </h2>

          {/* Bump 1: AI Web Closer */}
          <div className={`relative rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${bump1 ? 'bg-yellow-500/10 border-yellow-500' : 'bg-gray-900/50 border-dashed border-yellow-500/50 hover:border-yellow-500/80'}`} onClick={() => setBump1(!bump1)} data-id="element-1387" data-mp="1ged3jltp5q3v">
            {bump1 && <div className="absolute -top-3 -right-3 bg-yellow-500 text-black w-8 h-8 rounded-full flex items-center justify-center shadow-lg" data-id="element-1388" data-mp="11op5ctgtb7kd">
                <Check className="w-5 h-5 font-bold" data-id="element-1389" data-mp="xmu39mr24q5j" />
              </div>}
            <div className="flex items-start gap-4" data-id="element-1390" data-mp="1adckmxswxrjm">
              <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-colors ${bump1 ? 'bg-yellow-500 border-yellow-500' : 'border-gray-500'}`} data-id="element-1391" data-mp="1aaqb4smgp1yr">
                {bump1 && <Check className="w-4 h-4 text-black" data-id="element-1392" data-mp="1k8xtnfwefs2v" />}
              </div>
              <div className="flex-1" data-id="element-1393" data-mp="1p2s9274z1kw5">
                <div className="flex flex-wrap items-baseline gap-2 mb-1" data-id="element-1394" data-mp="1u0tzjd4q8mhn">
                  <h3 className="text-lg font-bold text-yellow-400" data-id="element-1395" data-mp="1u2wodtu589ks">
                    Sí, quiero AI Web Closer
                  </h3>
                  <span className="text-white font-black bg-yellow-500/20 px-2 py-0.5 rounded text-sm" data-id="element-1396" data-mp="230yx6vk4c6im">
                    +${bump1Price}
                  </span>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1397" data-mp="8nh6x0sbwvjw">
                  <span className="font-bold text-white" data-id="element-1398" data-mp="8pbqaanycflv">
                    Cierra ventas en automático.
                  </span>{' '}
                  Agrega el asistente de IA entrenado específicamente para
                  manejar objeciones y cerrar ventas por ti 24/7. El complemento
                  perfecto para tu producto digital.
                </p>
              </div>
            </div>
          </div>

          {/* Bump 2: Meta Ads Images */}
          <div className={`relative rounded-2xl p-5 md:p-6 transition-all duration-300 cursor-pointer border-2 ${bump2 ? 'bg-[#06b6d4]/10 border-[#06b6d4]' : 'bg-gray-900/50 border-dashed border-[#06b6d4]/50 hover:border-[#06b6d4]/80'}`} onClick={() => setBump2(!bump2)} data-id="element-1399" data-mp="3nkc971mhy92v">
            {bump2 && <div className="absolute -top-3 -right-3 bg-[#06b6d4] text-black w-8 h-8 rounded-full flex items-center justify-center shadow-lg" data-id="element-1400" data-mp="f2ofxvr1sbst">
                <Check className="w-5 h-5 font-bold" data-id="element-1401" data-mp="a6h6hszg0i64" />
              </div>}
            <div className="flex items-start gap-4" data-id="element-1402" data-mp="2zuhsg8z240dc">
              <div className={`mt-1 w-6 h-6 rounded border-2 flex-shrink-0 flex items-center justify-center transition-colors ${bump2 ? 'bg-[#06b6d4] border-[#06b6d4]' : 'border-gray-500'}`} data-id="element-1403" data-mp="2uulsqlxe6v3l">
                {bump2 && <Check className="w-4 h-4 text-black" data-id="element-1404" data-mp="1qwi1ks936m8l" />}
              </div>
              <div className="flex-1" data-id="element-1405" data-mp="1qufcqbjo6z5g">
                <div className="flex flex-wrap items-baseline gap-2 mb-1" data-id="element-1406" data-mp="1cxs2x86mcei4">
                  <h3 className="text-lg font-bold text-[#06b6d4]" data-id="element-1407" data-mp="1hw3g9sw4h753">
                    Sí, quiero Imágenes para Meta Ads
                  </h3>
                  <span className="text-white font-black bg-[#06b6d4]/20 px-2 py-0.5 rounded text-sm" data-id="element-1408" data-mp="136dyqn3q2qin">
                    +${bump2Price}
                  </span>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1409" data-mp="u7ag1k8gwd4o">
                  <span className="font-bold text-white" data-id="element-1410" data-mp="z5c8gvrs9ost">
                    Tráfico inmediato.
                  </span>{' '}
                  Aprende a crear imágenes estáticas de alta conversión para
                  Meta Ads usando IA. Deja de perder dinero en anuncios que
                  nadie clickea.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Summary + CTA */}
        <motion.div {...fadeIn} transition={{
        delay: 0.3
      }} className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-1411" data-mp="1l2jplquub1a">
          <div className="absolute -inset-4 bg-gradient-to-b from-[#06b6d4]/10 to-transparent blur-xl pointer-events-none" data-id="element-1412" data-mp="akz5nflv0vsn"></div>

          <div className="p-6 relative z-10" data-id="element-1413" data-mp="ojfat242qe8o">
            <h3 className="text-xl font-black mb-5" data-id="element-1414" data-mp="oi45uyyw70fz">Resumen de Orden</h3>

            <div className="space-y-3 mb-6" data-id="element-1415" data-mp="kimyu13thv8p">
              {/* Main Product */}
              <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1416" data-mp="y8yta6nvk630">
                <div className="flex items-center gap-3" data-id="element-1417" data-mp="tci55cgodrpx">
                  <Zap className="w-5 h-5 text-[#06b6d4]" data-id="element-1418" data-mp="1887tvid8wiyc" />
                  <span className="font-medium" data-id="element-1419" data-mp="188pokak9ep45">HeyLloyd Assistant</span>
                </div>
                <span className="font-bold" data-id="element-1420" data-mp="13axtj7obimvq">${mainPrice}</span>
              </div>

              {/* Bump 1 */}
              {bump1 && <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1421" data-mp="3k4srfemoeo9e">
                  <div className="flex items-center gap-3" data-id="element-1422" data-mp="3p3cfploqsc4x">
                    <CheckCircle2 className="w-5 h-5 text-yellow-500" data-id="element-1423" data-mp="3u1xh3ofqd1uy" />
                    <span className="font-medium" data-id="element-1424" data-mp="2uuoqto5opj5">AI Web Closer</span>
                  </div>
                  <span className="font-bold" data-id="element-1425" data-mp="31cgrszneq12y">${bump1Price}</span>
                </div>}

              {/* Bump 2 */}
              {bump2 && <div className="flex justify-between items-center py-2 border-b border-gray-800" data-id="element-1426" data-mp="36c33v5ri1ba6">
                  <div className="flex items-center gap-3" data-id="element-1427" data-mp="3b939jfkfsc0r">
                    <ImageIcon className="w-5 h-5 text-[#06b6d4]" data-id="element-1428" data-mp="3g0uunaktppji" />
                    <span className="font-medium" data-id="element-1429" data-mp="3g25yfae9qxam">Meta Ads Images</span>
                  </div>
                  <span className="font-bold" data-id="element-1430" data-mp="2il76lt49xnvj">${bump2Price}</span>
                </div>}
            </div>

            {/* Total */}
            <div className="flex justify-between items-center mb-6 pt-2" data-id="element-1431" data-mp="14pfir3ysxxfq">
              <p className="text-lg text-gray-400" data-id="element-1432" data-mp="14nbiqx40xikq">Total</p>
              <p className="text-3xl font-black text-white" data-id="element-1433" data-mp="10ovnk5xsh3w8">${total}</p>
            </div>

            {/* CTA Button */}
            <button onClick={handlePurchase} className="w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-black text-lg rounded-xl py-4 shadow-[0_0_20px_rgba(6,182,212,0.3)] hover:shadow-[0_0_30px_rgba(6,182,212,0.5)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-2 group" data-id="element-1434" data-mp="vn6ciqakgq85">
              COMPRAR AHORA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1435" data-mp="cyhs05fzwmww" />
            </button>

            <p className="text-center text-xs text-gray-500 mt-4" data-id="element-1436" data-mp="7xbyw6ifaxmu">
              Serás redirigido a Shopify para completar tu pago de forma segura.
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div {...fadeIn} transition={{
        delay: 0.4
      }} className="grid grid-cols-2 gap-4" data-id="element-1437" data-mp="1c898d4ewa4ma">
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-4 flex items-center gap-3" data-id="element-1438" data-mp="17ahiefxt8skq">
            <ShieldCheck className="w-8 h-8 text-emerald-400 shrink-0" data-id="element-1439" data-mp="1l01ex40sstll" />
            <div data-id="element-1440" data-mp="1gzrbnz4e4haf">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-1441" data-mp="1gz96gczr2sqd">
                Garantía 100%
              </p>
              <p className="text-xs text-gray-500" data-id="element-1442" data-mp="tapxdv8vmbx8">Libre de riesgo</p>
            </div>
          </div>
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-4 flex items-center gap-3" data-id="element-1443" data-mp="oc546fs1ksia">
            <Lock className="w-8 h-8 text-[#06b6d4] shrink-0" data-id="element-1444" data-mp="12c67e1vs4c0x" />
            <div data-id="element-1445" data-mp="xb8r5uubxs22">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-1446" data-mp="xaqly8pow3i0">
                Pago Seguro
              </p>
              <p className="text-xs text-gray-500" data-id="element-1447" data-mp="2dnx9a22wa9f7">Cifrado SSL</p>
            </div>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-1448" data-mp="2h7pbmxgbt2wz" />
    </div>;
}